import React, { lazy, Suspense } from "react"
import { createRoot } from 'react-dom/client';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { SharedStateProvider } from "./components/useSharedState";
import { RecoilRoot } from 'recoil'

const Home = lazy(() => import("./components/Home"))
const Login = lazy(() => import("./components/Login"))
const Calibration1 = lazy(() => import("./components/Calibration1"))
const Calibration2 = lazy(() => import("./components/Calibration2"))
const Calibration3 = lazy(() => import("./components/Calibration3"))
const Recording1 = lazy(() => import("./components/Recording1"))
const Recording2 = lazy(() => import("./components/Recording2"))
const Recording3 = lazy(() => import("./components/Recording3"))
const Results = lazy(() => import("./components/Results"))
const Yobou = lazy(() => import("./components/Yobou"))
const Error = lazy(() => import("./components/Error"))

function App() {
    return (
        <RecoilRoot>
            <SharedStateProvider>
                <Suspense fallback={<p>Loading...</p>}>
                    <BrowserRouter>
                        <Routes>
                            <Route path='/' element={<Login/>}/>
                            <Route path='/home' element={<Home/>}/>
                            <Route path='/calibration1' element={<Calibration1/>}/>
                            <Route path='/calibration2' element={<Calibration2/>}/>
                            <Route path='/calibration3' element={<Calibration3/>}/>
                            <Route path='/recording1' element={<Recording1/>}/>
                            <Route path='/recording2' element={<Recording2/>}/>
                            <Route path='/recording3' element={<Recording3/>}/>
                            <Route path='/results' element={<Results/>}/>
                            <Route path='/yobou' element={<Yobou/>}/>
                            <Route path='/error' element={<Error/>}/>

                        </Routes>
                    </BrowserRouter>
                </Suspense>
            </SharedStateProvider>
        </RecoilRoot>
    );
}

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
